// FAQ Section JavaScript
document.addEventListener("DOMContentLoaded", function () {
  // Initialize FAQ functionality
  initializeFAQ();
});

function initializeFAQ() {
  // Add click event listeners to all FAQ questions
  const faqQuestions = document.querySelectorAll(".faq-question");

  faqQuestions.forEach((question) => {
    // Ensure each question has proper ARIA attributes
    const answer = question.nextElementSibling;
    const toggle = question.querySelector(".faq-toggle");

    if (answer && answer.classList.contains("faq-answer")) {
      const questionId = "faq-" + Math.random().toString(36).substr(2, 9);
      answer.id = questionId;
      question.setAttribute("aria-expanded", "false");
      question.setAttribute("aria-controls", questionId);

      // Add keyboard support
      question.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleFAQ(this);
        }
      });
    }
  });
}

function toggleFAQ(questionElement) {
  const answer = questionElement.nextElementSibling;
  const isExpanded = questionElement.getAttribute("aria-expanded") === "true";

  // Close all other FAQ items
  const allQuestions = document.querySelectorAll(".faq-question");
  allQuestions.forEach((q) => {
    if (q !== questionElement) {
      closeFAQ(q);
    }
  });

  // Toggle current FAQ item
  if (isExpanded) {
    closeFAQ(questionElement);
  } else {
    openFAQ(questionElement);
  }
}

function openFAQ(questionElement) {
  const answer = questionElement.nextElementSibling;

  if (answer && answer.classList.contains("faq-answer")) {
    questionElement.classList.add("active");
    questionElement.setAttribute("aria-expanded", "true");

    // Smooth scroll to ensure the answer is visible
    setTimeout(() => {
      answer.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }, 300);
  }
}

function closeFAQ(questionElement) {
  const answer = questionElement.nextElementSibling;

  if (answer && answer.classList.contains("faq-answer")) {
    questionElement.classList.remove("active");
    questionElement.setAttribute("aria-expanded", "false");
  }
}

// Close FAQ when clicking outside
document.addEventListener("click", function (e) {
  if (!e.target.closest(".faq-item")) {
    const allQuestions = document.querySelectorAll(".faq-question");
    allQuestions.forEach((q) => {
      closeFAQ(q);
    });
  }
});

// Handle window resize to ensure proper layout
window.addEventListener("resize", function () {
  // Recalculate heights if needed
  const activeQuestions = document.querySelectorAll(".faq-question.active");
  activeQuestions.forEach((q) => {
    const answer = q.nextElementSibling;
    if (answer && answer.classList.contains("faq-answer")) {
      // Force reflow to ensure proper height calculation
      answer.style.maxHeight = "none";
      setTimeout(() => {
        answer.style.maxHeight = answer.scrollHeight + "px";
      }, 10);
    }
  });
});
